/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationsTenantRequest {
    getFixupPrototypeFunction() { return ListRecommendationsTenantRequest.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationsTenantRequest>): ListRecommendationsTenantRequest {
        let obj = Object.assign(new ListRecommendationsTenantRequest(), model);
        ListRecommendationsTenantRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationsTenantRequest>): ListRecommendationsTenantRequest {
        if (!model) return null;
        return ListRecommendationsTenantRequest.newInstance(<ListRecommendationsTenantRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationsTenantRequest) {
        if (!obj) return;

        models.ListRecommendationsTenantRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationsTenantRequest): boolean {
        Object.setPrototypeOf(obj, ListRecommendationsTenantRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page === undefined) {
            this.page = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
    }

    /**
     * page number.Example 'page': 1
     */
    page: number;

    /**
     * records limits.Example 'limit': 10
     */
    limit: number;

    /**
     * Classifications based on OSCAR pillars. Accepted values: Operation, Security, Cost, Access, Resource
     */
    classifications: string;

    /**
     * Sub-Classification based on the Classification selected.                                                                                                           Accepted Values:                                                                                                               \"Operation\": Performance, Availability, Standards, Logging, Monitoring                                                                                                               \"Security\": Data, Network, Host, Application, End Point protection, Standards                                                                                                               \"Cost\": Orphaned, Config, Idle, Underutilized, Anomaly, Billing, Budget, Overutilized, Optimized                                                                                                               \"Access\": Standards, Utilization                                                                                                               \"Resource\": Naming Standards, Tag Pattern, Locks
     */
    sub_classification: string;

    /**
     * Name of the Cloud. Accepted values - AWS, Azure, GCP
     */
    service_name: string;

    /**
     * Status. Acceptable values: open, resolved, skipped, system_skipped
     */
    status: string;

    /**
     * Mention the Cloud Account ID. Cloud Account ID can be retrieved from List Cost Savings Account Summary call.
     */
    service_account_id: string;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
